var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.state)?_c('v-icon',{attrs:{"disabled":_vm.disabled,"color":"#0f74bb"},on:{"click":function($event){return _vm.downloadLogFile(_vm.item)}}},[_vm._v(" mdi-download ")]):_c('v-progress-circular',{attrs:{"size":20,"color":"primary","indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }